import { z } from 'zod';
/**
 * Flow Control Split v1 Configuration Validator
 * Split nodes don't require any configuration
 */
export const Flow_Control_Split_1_ConfigValidator = z.object({});
//# sourceMappingURL=flow-control-split-1.js.map